<script>
  import { onMount } from "svelte";
  let campusName = 'Open Campus';

  if(window.location.host == 'portal.fiveislands.uwi.edu'){
    campusName = 'Five Islands Campus';
  }
  onMount (() => {
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })
  })
  </script>

<style>

  .nav-link .icon-rotate {
    transform: rotate(0deg);
    transition: transform 0.35s linear;
  }
  .nav-link:hover .icon-rotate {
    transform: rotate(-15deg);
  }

  .nav-link:hover .text-campus.icon-rotate {
    color:var(--bs-white)!important;
  }

  .nav-link .icon-rotate-right {
    transform: rotate(-15deg);
    transition: transform 0.35s linear;
  }
  .nav-link:hover .icon-rotate-right {
    transform: rotate(0deg);
  }

  .nav-link:hover .text-campus.icon-rotate-right {
    color:var(--bs-white)!important;
  }

  .nav-link .icon-rotate-350 {
    transform: rotate(0deg);
    transition: transform 0.35s linear;
  }
  .nav-link:hover .icon-rotate-350 {
    transform: rotate(350deg);
  }

  .nav-link:hover .text-campus.icon-rotate-350 {
    color:var(--bs-white)!important;
  }
  .nav-link .icon-zoom {
    transform: scale(1);
    margin-left: 0em;
    transition: all 0.35s linear;
  }
  .nav-link:hover .icon-zoom {
    transform: scale(0.5);
    margin-left: 0.2em;
  }
  .nav-link.bg-light-transparent .text-campus.icon-zoom {
    color:var(--bs-white)!important;
  }
  .nav-link:hover .text-campus.icon-zoom {
    color:var(--bs-white)!important;
  }



  </style>

<div class="sidebar d-flex flex-column flex-shrink-0 nav-campus campus shadow d-none d-sm-flex panel-0" style="width: 88px;">
  <a href="/" class="d-block py-3 text-center">
      <img src="/goto/jellyfish/crest_256x256.png"
        data-bs-toggle="tooltip" data-bs-placement="right" 
        title="The UWI {campusName}"
        class="shadow-logo d-none d-sm-flex" height="88"/>
    <span class="visually-hidden">Icon-only</span>
  </a>
  <ul class="nav nav-pills nav-flush flex-column mb-auto text-center scrollarea" style="overflow-y: auto;overflow-x: hidden;">
    <li class="nav-item">
      <a href="/" class="nav-link py-3 m-2 rounded" data-bs-toggle="tooltip" data-bs-placement="right" title="Portal">
        <i class="fas fa-fw fa-2x fa-home" />
        <br/><span class="d-block d-sm-none">Portal</span>
      </a>
    </li>
    <li>
      <a href="" class="nav-link bg-light-transparent py-3 m-2 rounded"  title="Password Reset" data-bs-toggle="tooltip" data-bs-placement="right">
        <i class="fas fa-fw fa-2x fa-key icon-rotate" />
        <br/><span class="d-block d-sm-none">Password Reset</span>
      </a>
    </li>
  </ul>
  <ul class="nav nav-pills nav-flush flex-column mt-auto text-center">

  </ul>
</div>

